import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import blockService from './blockService';

const initialState = {
  DeleteBlock: '',
  isDeleteBlockError: false,
  isDeleteBlockSuccess: false,
  isDeleteBlockLoading: false,
  isDeleteBlockErrorMsg: '',
  
  deleteMultiBlocks: '',
  isDeleteMultiBlocksError: false,
  isDeleteMultiBlocksSuccess: false,
  isDeleteMultiBlocksLoading: false,
  isDeleteMultiBlocksErrorMsg: '',
};

export const deleteBlock = createAsyncThunk(
  'deleteBlock/deleteBlock',

  async (state, thunkAPI) => {
    try {
      const response = await blockService.deleteBlock(state);
      return response;
    } catch (error) {
      const isDeleteBlockErrorMsg =
        (error.response && error.response.data && error.response.data.isDeleteBlockErrorMsg) ||
        error.isDeleteBlockErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(isDeleteBlockErrorMsg);
    }
  }
);


export const deleteMultiBlocks = createAsyncThunk(
  'deleteMultiBlocks/deleteMultiBlocks',

  async (state, thunkAPI) => {
    try {
      const response = await blockService.deleteMultiBlocks(state);
      return response;
    } catch (error) {
      const isDeleteMultiBlocksErrorMsg =
        (error.response && error.response.data) ||
        error.isDeleteMultiBlocksErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(isDeleteMultiBlocksErrorMsg);
    }
  }
);


export const deleteBlockSlice = createSlice({
  name: 'deleteBlock',
  initialState,
  reducers: {
    resetDeletBlock: (state) => {
      state.isDeleteBlockLoading = false;
      state.isDeleteBlockSuccess = false;
      state.isDeleteBlockError = false;
      state.isDeleteBlockErrorMsg = '';
    },
    resetDeleteMultiBlocks: (state) => {
      state.isDeleteMultiBlocksLoading = false;
      state.isDeleteMultiBlocksSuccess = false;
      state.isDeleteMultiBlocksError = false;
      state.isDeleteMultiBlocksErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteBlock.pending, (state) => {
        state.isDeleteBlockLoading = true;
      })
      .addCase(deleteBlock.fulfilled, (state, action) => {
        state.isDeleteBlockLoading = false;
        state.isDeleteBlockSuccess = true;
        state.DeleteBlock = action.payload;
      })
      .addCase(deleteBlock.rejected, (state, action) => {
        state.isDeleteBlockLoading = false;
        state.isDeleteBlockError = true;
        state.isDeleteBlockErrorMsg = action.payload; // error from catch will come here via action.payload and update isDeleteBlockErrorMsg
      })
      .addCase(deleteMultiBlocks.pending, (state) => {
        state.isDeleteMultiBlocksLoading = true;
      })
      .addCase(deleteMultiBlocks.fulfilled, (state, action) => {
        state.isDeleteMultiBlocksLoading = false;
        state.isDeleteMultiBlocksSuccess = true;
        state.deleteMultiBlocks = action.payload;
      })
      .addCase(deleteMultiBlocks.rejected, (state, action) => {
        state.isDeleteMultiBlocksLoading = false;
        state.isDeleteMultiBlocksError = true;
        state.isDeleteMultiBlocksErrorMsg = action.payload; // error from catch will come here via action.payload and update isDeleteBlockErrorMsg
      });
  },
});

export const { resetDeletBlock, resetDeleteMultiBlocks } = deleteBlockSlice.actions;
export default deleteBlockSlice.reducer;
